var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Location Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Location Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25862",
    fill: "none",
    d: "M0 0h74v74H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15009",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 219",
    d: "M37.003 36.973a8.481 8.481 0 10-8.482-8.481 8.491 8.491 0 008.482 8.481zm0-13.7a5.214 5.214 0 11-5.214 5.214 5.217 5.217 0 015.214-5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 220",
    d: "M36.998 5a23.94 23.94 0 00-24 24c0 14 12 28.322 20.752 38.387a4.882 4.882 0 003.172 1.61h.154a4.888 4.888 0 003.172-1.61C49.003 57.322 61.002 43.001 61.002 29A23.943 23.943 0 0036.998 5zm.244 60.8a2.545 2.545 0 01-.281.2 2.074 2.074 0 00-.267-.276c-7.6-8.747-20.437-23.51-20.437-37.019a20.744 20.744 0 1141.488 0c0 13.507-12.835 28.269-20.5 37.089z"
  }))))));
}

export default __webpack_public_path__ + "8a7180dd38c8037a83ee57b2f6b7d2ca.svg";
export { SvgLocationIcon as ReactComponent };